import { isDef } from "@redotech/util/checks";
import { assertNever } from "@redotech/util/type";

const basicCheckoutAnalyticsVersionEnum = [
  "basic", // If they don't have Shopify Plus, we can't use advanced analytics
] as const;

const advancedCheckoutAnalyticsVersionEnum = [
  "advanced-v08-13-2025", // ADVANCED_CHECKOUT_CONVERSION_METRICS_EARLIEST_DATE_TO_USE_FOR_ALL_SPLIT_METRICS
  "advanced-v09-16-2025", // When delivery options started being recorded on CHECKOUT_INFO_CHANGED customer events
] as const;
export type AdvancedCheckoutAnalyticsVersion =
  (typeof advancedCheckoutAnalyticsVersionEnum)[number];

export const checkoutAnalyticsVersionEnum = [
  ...basicCheckoutAnalyticsVersionEnum,
  ...advancedCheckoutAnalyticsVersionEnum,
] as const;
export type CheckoutAnalyticsVersion =
  (typeof checkoutAnalyticsVersionEnum)[number];

export const latestAdvancedCheckoutAnalyticsVersion: AdvancedCheckoutAnalyticsVersion =
  "advanced-v09-16-2025";
export const ADVANCED_CHECKOUT_CONVERSION_METRICS_EARLIEST_DATE_TO_USE_DELIVERY_OPTIONS =
  new Date("2025-09-16T00:00:00Z");
export const ADVANCED_CHECKOUT_CONVERSION_METRICS_EARLIEST_AVAILABLE_DATE =
  new Date("2025-07-27T12:00:00Z");
export const ADVANCED_CHECKOUT_CONVERSION_METRICS_EARLIEST_DATE_TO_USE_FOR_ALL_SPLIT_METRICS =
  new Date("2025-08-13T00:00:00Z");

export function isAdvancedCheckoutAnalyticsVersion(
  version: CheckoutAnalyticsVersion,
): version is AdvancedCheckoutAnalyticsVersion {
  return advancedCheckoutAnalyticsVersionEnum.includes(
    version as unknown as AdvancedCheckoutAnalyticsVersion,
  );
}

export function getCheckoutAnalyticsVersionForSplit({
  shouldUseAdvanced,
  splitStartDate,
  splitAnalyticsVersionOverride,
}: {
  shouldUseAdvanced: boolean;
  splitStartDate: Date | undefined;
  splitAnalyticsVersionOverride: CheckoutAnalyticsVersion | undefined;
}): CheckoutAnalyticsVersion {
  if (isDef(splitAnalyticsVersionOverride)) {
    switch (splitAnalyticsVersionOverride) {
      case "basic":
        // No reason to prevent override to basic
        return "basic";
      case "advanced-v08-13-2025":
        if (
          splitStartDate &&
          splitStartDate.getTime() >
            ADVANCED_CHECKOUT_CONVERSION_METRICS_EARLIEST_DATE_TO_USE_FOR_ALL_SPLIT_METRICS.getTime()
        ) {
          return "advanced-v08-13-2025";
        }
        break;
      case "advanced-v09-16-2025":
        if (
          splitStartDate &&
          splitStartDate.getTime() >
            ADVANCED_CHECKOUT_CONVERSION_METRICS_EARLIEST_DATE_TO_USE_DELIVERY_OPTIONS.getTime()
        ) {
          return "advanced-v09-16-2025";
        }
        break;
      default:
        assertNever(splitAnalyticsVersionOverride);
    }
  }

  if (
    shouldUseAdvanced &&
    splitStartDate &&
    splitStartDate.getTime() >
      ADVANCED_CHECKOUT_CONVERSION_METRICS_EARLIEST_DATE_TO_USE_DELIVERY_OPTIONS.getTime()
  ) {
    return "advanced-v09-16-2025";
  } else if (
    shouldUseAdvanced &&
    splitStartDate &&
    splitStartDate.getTime() >
      ADVANCED_CHECKOUT_CONVERSION_METRICS_EARLIEST_DATE_TO_USE_FOR_ALL_SPLIT_METRICS.getTime()
  ) {
    return "advanced-v08-13-2025";
  } else {
    return "basic";
  }
}
